import React from 'react';
import { Search } from 'lucide-react';

interface Department {
  id: number;
  name: string;
  code: string;
}

interface RoleAccessFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  selectedDivision: string;
  setSelectedDivision: (value: string) => void;
  departments: Department[];
}

export default function RoleAccessFilters({
  searchTerm,
  setSearchTerm,
  selectedDivision,
  setSelectedDivision,
  departments,
}: RoleAccessFiltersProps) {
  return (
    <div className="w-full bg-white rounded-lg shadow-md p-4">
      <div className="flex gap-4">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none z-10" />
          <input
            type="text"
            placeholder="Cari role..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm placeholder:text-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
          />
        </div>
        <div className="w-64">
          <select
            value={selectedDivision}
            onChange={e => setSelectedDivision(e.target.value)}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 bg-white"
          >
            <option value="">Semua Divisi</option>
            {departments.map(dept => (
              <option key={dept.id} value={dept.id.toString()}>
                {dept.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
